/* istanbul ignore file */
import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import ArrowIcon from '@mui/icons-material/ArrowDropDownOutlined';
import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { GroupBase, IndicatorsContainerProps } from 'react-select';

type SelectOptionWithValue = {
  value?: unknown;
};

const hasOptionValue = (value: unknown): value is SelectOptionWithValue =>
  value != null && typeof value === 'object' && 'value' in value;

export const IndicatorsContainer = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: IndicatorsContainerProps<Option, IsMulti, Group>,
) => {
  const {
    hasValue,
    selectProps: { value: selectValue, isClearable },
  } = props;

  return (
    <>
      {isClearable && hasValue && hasOptionValue(selectValue) && selectValue.value && <ClearIndicator {...props} />}
      <DropdownIndicator />
    </>
  );
};

const DropdownIndicator = ({ sx = {} }: { sx?: SxProps<Theme> }) => {
  return (
    <IconButton className="dropdown__indicator" sx={{ padding: '2px', marginRight: '-2px', ...sx }}>
      <ArrowIcon sx={{ color: 'text.secondary', width: '0.9em', height: '0.9em' }} />
    </IconButton>
  );
};

const ClearIndicator = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: IndicatorsContainerProps<Option, IsMulti, Group>,
) => {
  const { clearValue } = props;

  const onClick = (e: React.MouseEvent<HTMLButtonElement> | React.TouchEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    clearValue();
  };

  return (
    <IconButton
      onMouseDown={onClick}
      onTouchEnd={onClick}
      className="dropdown__clear-indicator"
      sx={{ opacity: 0, padding: '5px', marginRight: '-2px', '@media (hover: none)': { opacity: 1 } }}
    >
      <CloseIcon sx={{ color: 'text.secondary', fontSize: '18px' }} />
    </IconButton>
  );
};
